import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { WitnessSignatureService } from '@pages/signature-witness/witness-signature.service';
import { WitnessSignatureResponse } from '@shared/models/interfaces/witnessSignature.interface';
import { UtilsService } from '@shared/providers/utils.service';
import { WitnessState } from '@shared/store/witness/witness.state';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-second-step',
  templateUrl: './second-step.page.html',
  styleUrls: ['./second-step.page.scss'],
})
export class SecondStepPage implements OnInit {
  public tokenForm: FormGroup;
  public signatureData: WitnessSignatureResponse;
  public email: string;
  public signatureId: string;
  public link: string;
  constructor(
    private formBuilder: FormBuilder,
    private store: Store,
    private utils: UtilsService,
    private signatureService: WitnessSignatureService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private platform: Platform
  ) {}
  get witnessSignatureToken() {
    return this.tokenForm.get('witnessSignatureToken');
  }

  async ngOnInit() {
    this.tokenForm = this.initializeForm();
    this.signatureId = this.activatedRoute.snapshot.paramMap.get('id');
    this.email = history.state ? history.state.email : null;
    const { witnessSignature } = await this.signatureService.getWitnessSignatureData(this.signatureId);
    this.link = witnessSignature.surveyReportLink;
  }
  initializeForm() {
    return this.formBuilder.group({
      witnessSignatureToken: ['', Validators.required],
    });
  }

  download() {
    if (this.platform.is('cordova')) {
      saveAs(this.link, 'relatorio.pdf');
    } else {
      window.open(this.link, '_blank');
    }
  }

  async sign(form: FormGroup) {
    const formData = form.getRawValue();
    if (form.invalid) {
      this.utils.validateAllFields(form);
    } else {
      const signatureId = this.activatedRoute.snapshot.paramMap.get('id');
      const witnessData = this.store.selectSnapshot(
        WitnessState.getWitnessSignatureData
      ).witnessSignatureRequest;
      witnessData.witnessSignatureToken = formData.witnessSignatureToken.toString().replace(/\s/g, '');
      try {
        await this.signatureService.update(witnessData, signatureId);
        this.router.navigate(['testemunha', 'assinar', 'concluido']);
      } catch (error) {
        console.error(error);
        if (error?.error?.code) {
          this.utils.showToast('', error.error.message);
        } else {
          this.utils.showToast('', `${this.translate.instant('SIGNATURE.ERROR_SENDING_TOKEN')}`);
        }
      }
    }
  }

  async resend() {
    try {
      const signatureId = this.activatedRoute.snapshot.paramMap.get('id');
      await this.signatureService.resendToken(signatureId);
      this.utils.showToast('', `${this.translate.instant('SIGNATURE.A_NEW_EMAIL_WITH')}`);
    } catch (error) {
      console.error(error);
      if (error?.error?.code) {
        this.utils.showToast('', error.error.message);
      } else {
        this.utils.showToast('', `${this.translate.instant('SIGNATURE.ERROR_REQUESTING_EMAIL')}`);
      }
    }
  }
}
